import React, { Component } from 'react'
import Select from 'react-select';
import api from '../../services/api';
import moment from 'moment';
import { toast } from 'react-toastify';
import Logo from '../../assets/logo.png';
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable';


class RelatorioPorServico extends Component {

    constructor(props){
        super(props);
        
        
        this.state = {
            isLoandingPage: false,
            isPreview: false,
            clientes:'',
            cliente:'',
            atendentes:'',
            atendente:'', 
            dataInicial:'',
            dataFinal:'', 
            totalQuantidade:0,
            totalValor:0,
            viewReports: []
        }   
        
        this.imprimir           = this.imprimir.bind(this)
        this.executar         = this.executar.bind(this)      
        this.voltar           = this.voltar.bind(this)
      
    }

    async componentDidMount() {
        const token    = sessionStorage.getItem('token');

        this.setState({isLoandingPage: true});

        const listarPessoas = await api.get('/api/pessoa', {
            headers: {
                'x-access-token':token,
            }
        });

        const clientes = [];
        const atendentes = [];
        listarPessoas.data.forEach(element => {
            clientes.push({value: element.id, label:element.razao })
            if( element.tipo === 2 ) atendentes.push({value: element.id, label:element.razao })
        });

        let hoje = new Date();
        this.setState({
            isLoandingPage: false,
            isPreview: false,
            clientes:clientes,
            cliente:'',
            atendentes: atendentes,
            atendente:'',
            dataInicial: moment(hoje).format('YYYY-MM-DD'),
            dataFinal:moment(hoje).format('YYYY-MM-DD'),
            totalQuantidade:0,
            totalValor:0,
            viewReports: []            
        })  
        this.setState({isLoandingPage: false});
    }

    executar = async() => {
        const token    = sessionStorage.getItem('token');        
        const { situacao, cliente, clientes, atendente, atendentes, filtro, dataInicial, dataFinal} = this.state;
        
        if( !dataInicial) return toast.error("Informe data inicial.");
        if( !dataFinal ) return toast.error("Informe data final.");

        const vendas = await api.post('/api/faturamentoPorServico',{ cliente, clientes, atendente, atendentes, dataInicial, dataFinal}, {
            headers: {
                'x-access-token':token,
            }
        })
        let valor = 0;
        for (let index = 0; index <  vendas.data.length; index++) {
            const item =  vendas.data[index];
            valor +=  Number(item.total);
        }
        
        this.setState({
            isPreview: true,
            isLoandingPage: true,
            clientes:clientes,
            cliente: cliente,
            atendentes: atendentes,
            atendente:atendente,
            dataInicial: moment(dataInicial).format('YYYY-MM-DD'),
            dataFinal:moment(dataFinal).format('YYYY-MM-DD'),
            totalValor:valor,
            viewReports: vendas.data
        })
    }

    voltar = async() => {
        const token    = sessionStorage.getItem('token');

        this.setState({isLoandingPage: true});

        const listarPessoas = await api.get('/api/pessoa', {
            headers: {
                'x-access-token':token,
            }
        });

        const clientes = [];
        const atendentes = [];
        listarPessoas.data.forEach(element => {
            clientes.push({value: element.id, label:element.razao })
            if( element.tipo === 2 ) atendentes.push({value: element.id, label:element.razao })
        });

        let hoje = new Date();
        this.setState({
            isLoandingPage: false,
            isPreview: false,
            clientes:clientes,
            cliente:'',
            atendentes: atendentes,
            atendente:'',
            dataInicial: moment(hoje).format('YYYY-MM-DD'),
            dataFinal:moment(hoje).format('YYYY-MM-DD'),
            viewReports: []            
        })  
        this.setState({isLoandingPage: false});
    }

    imprimir = async () => {

        const licenciada    = sessionStorage.getItem('razao')
        var hoje = new Date();
        var hsemissao = hoje.toISOString().split("T")[1].split(".")[0]
        var dtemissao = hoje.toISOString().split("T")[0].split("-").reverse().join("/")
  
        const doc = new jsPDF()
               
        var total = this.state.viewReports.reduce((sum, el) => sum + Number(el.total), 0);
        var body = [...this.state.viewReports.map((el) => [el.servico, Number(el.total).toFixed(2)]), 
        [{content: `Total = ${Number(total).toFixed(2)}`, colSpan: 5, 
         styles: { fillColor: [239, 154, 154] }
        }]]
              
        autoTable(doc, {            
          head: [['Serviço','Total']],
          body: body,
          startY: 22, 
          didDrawPage: function (data) {
                doc.setFontSize(12)
                doc.text(`Empresa: ${ licenciada }`, 30, 12)
                doc.text(`Data: ${dtemissao}`, 30, 16)
                doc.text(`Hora: ${hsemissao}`, 30, 20)
            
                doc.setFontSize(11)
                doc.addImage(Logo, 'JPEG', data.settings.margin.left, 5, 15, 15);
            }
    
        })
        doc.save(`${hoje.getTime().toString()}.pdf`)
         
    }
    
    render() {        
        return ( 
            <div className="wrapper">
                <div className="content-wrapper">
                    <section className="content-header">
                           
                        <div className="card">
                            <div className="card-header">
                                <h3 className="card-title"><i class="fas fa-file-pdf"></i> Faturamento Por Serviço</h3>

                                <div className="card-tools">
                                    <button type="button" className="btn btn-tool" data-card-widget="Atualizar" data-toggle="Atualizar" title="Atualizar" onClick={ () => {} }>
                                        <i className="fas fa-sync"></i>
                                    </button>
                                
                                    <button type="button" className="btn btn-tool" data-card-widget="Minimizar" data-toggle="Minimizar" title="Minimizar">
                                        <i className="fas fa-minus"></i>
                                    </button>
                                
                                </div>
                            </div>
                            <div className="card-body">
                                <div className="card card-primary card-outline card-tabs">
                                    <div className="card-header p-0 pt-1 border-bottom-0">
                                        <ul className="nav nav-tabs" id="custom-tabs-two-tab" role="tablist">
                                            <li className="nav-item">
                                                <a className={ `nav-link ${ !this.state.isPreview ? 'active' : ''}`} id="custom-tabs-listagem-dados-tab" data-toggle="pill" onClick={ () => {}} href="#custom-tabs-listagem-dados" role="tab" aria-controls="custom-tabs-listagem-dados" aria-selected={ this.state.isPreview  ? true : false }>Variáveis</a>
                                            </li>
                                            <li className="nav-item">
                                                <a className={ `nav-link ${ this.state.isPreview ? 'active' : ''}` } id="custom-tabs-edicao-dados-tab" data-toggle="pill" onClick={() =>{} } href="#custom-tabs-edicao-dados" role="tab" aria-controls="custom-tabs-edicao-dados" aria-selected={ !this.state.isPreview  ? true : false }>Relatório</a>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="card-body">
                                        
                                        <div className="tab-content" id="custom-tabs-two-tabContent">
                                            <div className={`tab-pane ${ this.state.isPreview ? 'tab-pane fade' : 'fade show active' }`} id="vert-tabs-lista" role="tabpanel" aria-labelledby="vert-tabs-lista-tab">
                                                <div class="row">
                                                    <div class="col-sm-4">
                                                        <div class="form-group">
                                                            <label>Cliente</label>
                                                            <Select
                                                                id="cliente"
                                                                placeholder="Selecione" 
                                                                isSearchable="true"
                                                                options={this.state.clientes}
                                                                onChange={e => this.setState({cliente: e.value})}
                                                            />
                                                        </div>
                                                    </div>                                                            
                                                </div>
                                                <div class="row">
                                                    <div class="col-sm-4">
                                                        <div class="form-group">
                                                            <label>Atendente</label>
                                                            <Select
                                                                id="atendente"
                                                                placeholder="Selecione" 
                                                                isSearchable="true"
                                                                options={this.state.atendentes}
                                                                onChange={e => this.setState({atendente: e.value})}
                                                            />
                                                        </div>
                                                    </div>                                                   
                                                </div>
                                                <div class="row">
                                                    <div class="col-sm-4">
                                                        <div class="form-group">
                                                            <label>Data Inicial</label>
                                                            <input type="date" class="form-control" placeholder="" value={ this.state.dataInicial } onChange={e => this.setState({dataInicial: e.target.value})} required />
                                                        </div>
                                                    </div>
                                                    <div class="col-sm-4">
                                                        <div class="form-group">
                                                            <label>Data Final</label>
                                                            <input type="date" class="form-control" placeholder="" value={ this.state.dataFinal } onChange={e => this.setState({dataFinal: e.target.value})} required />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="card-footer clearfix">
                                                    <button type="button" class="btn btn-success"  onClick={ this.executar }>Executar</button>
                                                    <button type="button" class="btn btn-danger" onClick={ this.voltar }>Limpar</button>                                 
                                                </div>
                                         
                                            </div>
                                         
                                            <div className={`tab-pane ${ !this.state.isPreview ? 'tab-pane fade' : 'fade show active' }`} id="custom-tabs-edicao-dados" role="tabpanel" aria-labelledby="custom-tabs-edicao-dados-tab">
                                                <div class="col-12">
                                                    { 
                                                        this.state.viewReports.length > 0 ?
                                                        <div class="invoice p-3 mb-3">
                                                            <div class="row">
                                                                <div class="col-12">
                                                                    <h4>
                                                                        <img src={ Logo } width="120" height="105"/>
                                                                        <small class="float-right">

                                                                            <div className="card-tools">    
                                                                                <button className="btn btn-tool "target="_blank" onClick={ e => this.imprimir( this.state.itens )}>
                                                                                    <i class="fas fa-print"></i> Imprimir
                                                                                </button>                                                        
                                                                                <button type="button" className="btn btn-tool" onClick={ this.voltar }>
                                                                                    <i class="fas fa-reply"></i> Voltar
                                                                                </button>
                                                                            </div>               
                                                                        </small>
                                                                    </h4>
                                                                </div>
                                                                <div class="card-body table-responsive p-0" >
                                                                    <table  class="table table-head-fixed text-nowrap">
                                                                        <thead>
                                                                            <tr>
                                                                                <th>Serviço</th>
                                                                                <th>Total</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {
                                                                                this.state.viewReports.map(item => (
                                                                                            
                                                                                    <tr key={ item.id }>
                                                                                        <td>{ item.servico }</td>
                                                                                        <td>{ item.total ? item.total.toFixed(2) : 0.00 }</td>                                                                                    
                                                                                    </tr> 
                                                                                    
                                                                                ))
                                                                            }
                                                                            <tr>
                                                                                <td><p>Total Geral:</p></td>
                                                                                <td>{ this.state.totalValor.toFixed(2) }</td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        : 
                                                        <div>
                                                            Nenhuma informação foi encontrada.<br></br>
                                                            <button type="button" class="btn btn-danger" onClick={ this.voltar }>Voltar</button>  

                                                        </div>

                                                    }
                                                </div>
                                            
                                            </div>
                                        </div>     
                                                                          
                                    </div>
                                    {
                                        this.isLoandingPage ?                                    
                                        <div class="overlay d-flex justify-content-center align-items-center">
                                            <i class="fas fa-2x fa-sync fa-spin"></i>
                                        </div>
                                        : ''
                                   
                                    }
                                </div>
                                
                            </div> 
                            <div className="card-footer">                        
                            </div>
                        </div>

                    </section>
                </div>
                
            </div>
        )
    }
        
}

export default RelatorioPorServico;